import React, { useCallback } from 'react';
import bem from 'utils/bem.js';
import { RequestPermissionPopover } from './RequestPermissionPopover';
import { VideoButton } from '../../components/VideoButton';
import { useRoomContext } from '../../contexts/RoomContext';
import { handleError } from '../../utils/handleError';

const { block, el } = bem('request-permission-button');
export const RequestPermissionAudio = ({ isAudioMuted }) => {

    const { room } = useRoomContext();

    const toggleMute = useCallback(async () => {
        try {
            await room.muteAudioInput(!isAudioMuted);
        } catch (error) {
            handleError(error, 'Ошибка при выключении микрофона');
        }
    }, [room, isAudioMuted]);

    return (
        <RequestPermissionPopover
            className={ block('audio') }
            room={room}
            permissionName={'canShareAudio'}
            isMuted={isAudioMuted}
            toggleMute={toggleMute}
        >
            <VideoButton name={ isAudioMuted ? 'microphone-slash' : 'microphone-shadow' } active={ isAudioMuted }/>
        </RequestPermissionPopover>
    )
};
